module.exports = __webpack_public_path__ + "media/components/src/assets/images/what_day/crown3-553693fb3a0298972c2b8631a216c8ca.png";